/**
 * @generated SignedSource<<26660bcb199f121ecc5b5818c5bdd633>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GroupTemplatesTablePaginationFragment_groupModules$data = {
  readonly moduleGroups: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly flow: {
          readonly durationSeconds: number;
          readonly name: string;
          readonly rowId: UUID;
          readonly updatedAt: Date | null | undefined;
        } | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"GroupTemplateCard_moduleGroup">;
      };
    }>;
    readonly totalCount: number;
  } | null | undefined;
  readonly " $fragmentType": "GroupTemplatesTablePaginationFragment_groupModules";
};
export type GroupTemplatesTablePaginationFragment_groupModules$key = {
  readonly " $data"?: GroupTemplatesTablePaginationFragment_groupModules$data;
  readonly " $fragmentSpreads": FragmentRefs<"GroupTemplatesTablePaginationFragment_groupModules">;
};

import GroupTemplatesTablePaginationQuery_Refetchable_graphql from './GroupTemplatesTablePaginationQuery_Refetchable.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "moduleGroups"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "moduleGroupsFilter"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "moduleGroupsOrderBy"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": GroupTemplatesTablePaginationQuery_Refetchable_graphql
    }
  },
  "name": "GroupTemplatesTablePaginationFragment_groupModules",
  "selections": [
    {
      "alias": "moduleGroups",
      "args": [
        {
          "kind": "Variable",
          "name": "filter",
          "variableName": "moduleGroupsFilter"
        },
        {
          "kind": "Variable",
          "name": "orderBy",
          "variableName": "moduleGroupsOrderBy"
        }
      ],
      "concreteType": "ModuleGroupsConnection",
      "kind": "LinkedField",
      "name": "__GroupTemplatesTable_moduleGroups_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ModuleGroupsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ModuleGroup",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "GroupTemplateCard_moduleGroup"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Flow",
                  "kind": "LinkedField",
                  "name": "flow",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "rowId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "durationSeconds",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "b4a1fd4357b7643c5cdcdab56e89db56";

export default node;
